import React, { createContext, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "@config/config";

export const VoucherManagerContext = createContext({});

const VoucherManagerContextProvider = ({ children }) => {
    const [selectedFilters, setSelectedFilters] = useState({
        cinemaGroups: [],
        ticketClasses: [],
        ticketTypes: []
    });
    const [isVoucherBucketSearchLoading, setIsVoucherBucketSearchLoading] = useState(false);
    const [hasLoadedVouchers, setHasLoadedVouchers] = useState(false);
    const [allVouchers, setAllVouchers] = useState([]);
    const [voucherQuantity, setVoucherQuantity] = useState(0);


    const fetchVoucherBucketSearch = async () => {
        setIsVoucherBucketSearchLoading(true);
        try {
            const response = await axios.get(`${API_BASE_URL}/voucher-manager/voucher-search`);
            if (response.data.successUrl) {
                window.open(response.data.data, "_self");
                return;
            }

            const voucherBuckets = response?.data?.data?.voucher_buckets;

            if (!Array.isArray(voucherBuckets)) {
                console.warn("Unexpected API response shape:", response.data);
                setAllVouchers([]);
                setHasLoadedVouchers(true);
                return;
            }
            setAllVouchers(voucherBuckets);
            setHasLoadedVouchers(true);

        } catch (error) {
            setAllVouchers([]);
            setHasLoadedVouchers(true);
            console.error("Network error fetching vouchers:", error);
        } finally {
            setIsVoucherBucketSearchLoading(false);
        }
    };

    return (
        <VoucherManagerContext.Provider
            value={{
                vouchers: allVouchers,
                selectedFilters,
                setSelectedFilters,
                fetchVoucherBucketSearch,
                isVoucherBucketSearchLoading,
                hasLoadedVouchers,
                voucherQuantity,
                setVoucherQuantity,
            }}
        >
            {children}
        </VoucherManagerContext.Provider>
    );
};

export default VoucherManagerContextProvider;
